<template>
  <div>
    <b-form>
      <div class="premium-card shadow-sm mb-4">
        <div class="card-header-premium">
          <i class="fa fa-id-card mr-2"></i> IDENTIFICAÇÃO
        </div>
        <div class="p-3">
          <b-row>
            <b-col md="3">
              <b-form-group label="Código Transportador" class="premium-form-group">
                <transportadora-pesquisa ref="transportadora" :idInicial="nfe.ID_TRANSPORTADOR ? Number(nfe.ID_TRANSPORTADOR) : undefined" :desabilitarInput="isLoadingFromBackend || !podeEditar" @retornaId="onTransportadoraSelected" place=""/>
              </b-form-group>
            </b-col>

            <b-col md="5">
              <b-form-group label="Razão Social / Nome" class="premium-form-group">
                <b-form-input v-model="nfe.TX_RAZAO_SOCIAL_TRANSP" readonly maxlength="60" class="rounded-pill bg-light" />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="Tipo" class="premium-form-group">
                <b-form-select v-model="nfe.OP_TIPO_DOC_TRANSP" :options="tipoOptions" class="rounded-pill" @change="onTipoChange" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="CNPJ/CPF" class="premium-form-group">
                <b-form-input v-model="nfe.TX_NUM_CNPJ_TRANSP" :placeholder="cnpjCpfPlaceholder" maxlength="14" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group label="Inscrição Estadual" class="premium-form-group">
                <b-form-input v-model="nfe.TX_NUM_IE_TRANSP" maxlength="14" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>

            <b-col md="3" class="d-flex align-items-center pt-3">
              <b-form-checkbox v-model="isentoIcms" class="custom-control-primary" @change="onIsentoChange" :disabled="!podeEditar">Isento do ICMS</b-form-checkbox>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="premium-card shadow-sm mb-4">
        <div class="card-header-premium">
          <i class="fa fa-map-marker mr-2"></i> ENDEREÇO
        </div>
        <div class="p-3">
          <b-row>
            <b-col md="6">
              <b-form-group label="Logradouro" class="premium-form-group">
                <b-form-input v-model="nfe.TX_LOGRADOURO_TRANSP" readonly maxlength="60" class="rounded-pill bg-light" />
              </b-form-group>
            </b-col>

            <b-col md="2">
              <b-form-group label="UF" class="premium-form-group">
                <b-form-select v-model="nfe.ID_UF_TRANSP" :options="ufOptions" class="rounded-pill" :disabled="!podeEditar" />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="Município" class="premium-form-group">
                <b-input-group>
                  <b-form-input v-model="nfe.ID_MUNICIPIO_TRANSP" readonly class="rounded-left-pill bg-light" />
                  <b-input-group-append>
                    <b-button variant="outline-primary" class="rounded-right-pill" @click.prevent="onMunicipioLookup" :disabled="!podeEditar">
                      <i class="fa fa-search"></i>
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'NfeTranspTransporte',
  props: { 
    nfe: { type: Object, required: true },
    isLoadingFromBackend: { type: Boolean, default: false },
    podeEditar: { type: Boolean, default: false }
  },
  data() {
    return {
      tipoOptions: [
        { value: '0', text: 'CPF - Física' },
        { value: '1', text: 'CNPJ - Jurídica' }
      ],
      ufOptions: [/* TODO: load from CDSUFNFE or store */]
    }
  },
  components: {
    // use existing transportadora pesquisa component for lookup
    TransportadoraPesquisa: () => import('@/views/pesquisa/TransportadoraPesquisa.vue')
  },
  computed: {
    cnpjCpfPlaceholder() { return this.nfe.OP_TIPO_DOC_TRANSP === '1' ? '00.000.000/0000-00' : '000.000.000-00' },
    isentoIcms: {
      get() { return this.nfe.OP_ICMS_ISENTO_TRANSP === '1' },
      set(val) { this.$set(this.nfe, 'OP_ICMS_ISENTO_TRANSP', val ? '1' : '0') }
    }
  },
  methods: {
    emitInput() {
      this.$emit('input', this.nfe)
      this.$emit('changed')
    },
    onTransportadorLookup() {
      // abrir modal programaticamente
      if (this.$refs.transportadora && this.$refs.transportadora.$refs && this.$refs.transportadora.$refs.modalTransportadora) {
        this.$refs.transportadora.$refs.modalTransportadora.show = true
      } else {
        this.$emit('open-transportador-lookup')
      }
    },
    async onTransportadoraSelected(id) {
      console.log('[NfeTranspTransporte] onTransportadoraSelected:', { id, isLoadingFromBackend: this.isLoadingFromBackend })
      
      // IGNORAR eventos durante carregamento do backend
      if (this.isLoadingFromBackend) {
        console.log('[NfeTranspTransporte] Evento ignorado - carregando do backend')
        return
      }
      
      // quando o X é clicado, TransportadoraPesquisa emite null - limpa tudo
      if (id === null || id === '' || id === undefined) {
        this.limparTransportadora()
        return
      }
      
      // busca detalhes da transportadora via API
      try {
        this.$set(this.nfe, 'ID_TRANSPORTADOR', id)
        const resp = await this.$http.get(`/api/protected/transportadora/getById/${id}`)
        const transp = resp && resp.data ? (Array.isArray(resp.data) ? resp.data[0] : resp.data) : null
        
        if (transp) {
          this.aplicarDadosTransportadora(transp)
        }
      } catch (err) {
        console.error('Erro ao carregar transportadora:', err)
        this.toast('Falha ao carregar dados da transportadora', 'danger', err)
      }
    },
    aplicarDadosTransportadora(transp) {
      // mapeia campos do backend para o modelo MAIUSCULO direto
      this.$set(this.nfe, 'ID_TRANSPORTADOR', transp.ID || transp.CODIGO)
      this.$set(this.nfe, 'TX_RAZAO_SOCIAL_TRANSP', transp.NOME || transp.RESUMIDO || '')
      this.$set(this.nfe, 'OP_TIPO_DOC_TRANSP', transp.OP_TIPO_CNPJ != null ? String(transp.OP_TIPO_CNPJ) : '1')
      this.$set(this.nfe, 'TX_NUM_CNPJ_TRANSP', this.normalizaDoc(transp.CGC) || '')
      this.$set(this.nfe, 'TX_NUM_IE_TRANSP', transp.IE || '')
      this.$set(this.nfe, 'OP_ICMS_ISENTO_TRANSP', (transp.OP_ISENTO_ICMS === '1' || transp.OP_ISENTO_ICMS === 1) ? '1' : '0')
      
      // endereco
      this.$set(this.nfe, 'TX_LOGRADOURO_TRANSP', transp.ENDERECO || '')
      this.$set(this.nfe, 'ID_UF_TRANSP', transp.ID_UF || transp.UF || '')
      this.$set(this.nfe, 'ID_MUNICIPIO_TRANSP', transp.ID_MUNICIPIO || '')
      
      this.emitInput()
    },
    limparTransportadora() {
      this.$set(this.nfe, 'ID_TRANSPORTADOR', null)
      this.$set(this.nfe, 'TX_RAZAO_SOCIAL_TRANSP', '')
      this.$set(this.nfe, 'OP_TIPO_DOC_TRANSP', '1')
      this.$set(this.nfe, 'TX_NUM_CNPJ_TRANSP', '')
      this.$set(this.nfe, 'TX_NUM_IE_TRANSP', '')
      this.$set(this.nfe, 'OP_ICMS_ISENTO_TRANSP', '0')
      this.$set(this.nfe, 'TX_LOGRADOURO_TRANSP', '')
      this.$set(this.nfe, 'ID_UF_TRANSP', '')
      this.$set(this.nfe, 'ID_MUNICIPIO_TRANSP', '')
      this.emitInput()
    },
    normalizaDoc(v) {
      return (v || '').toString().replace(/\D+/g, '')
    },
    onMunicipioLookup() {
      // origem: contexto/Unt_NotaFiscalEletronica.dfm: ComboID_MUNICIPIO_TRANSP
      // TODO: implement municipio lookup
      this.$emit('open-municipio-lookup')
    },
    onTipoChange() {
      // IGNORAR eventos durante carregamento do backend
      if (this.isLoadingFromBackend) {
        return
      }
      
      // limpa CNPJ/CPF se o tipo mudou e o documento não corresponde
      const doc = this.normalizaDoc(this.nfe.TX_NUM_CNPJ_TRANSP)
      if (this.nfe.OP_TIPO_DOC_TRANSP === '0' && doc.length === 14) {
        this.$set(this.nfe, 'TX_NUM_CNPJ_TRANSP', '') // CPF esperado
      }
      if (this.nfe.OP_TIPO_DOC_TRANSP === '1' && doc.length === 11) {
        this.$set(this.nfe, 'TX_NUM_CNPJ_TRANSP', '') // CNPJ esperado
      }
      this.emitInput()
    },
    onIsentoChange(val) {
      // IGNORAR eventos durante carregamento do backend
      if (this.isLoadingFromBackend) {
        return
      }
      
      this.$set(this.nfe, 'OP_ICMS_ISENTO_TRANSP', val ? '1' : '0')
      this.emitInput()
    },
    toast(msg, variant = 'info', err) {
      const desc = err && (err.message || err.response?.data || err.toString())
      this.$bvToast && this.$bvToast.toast(desc ? `${msg}: ${desc}` : msg, {
        title: 'Transportadora',
        variant,
        autoHideDelay: 3500,
        solid: true
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/faturamento/nfe/partials/NfeTranspTransporte.vue